import React, { useEffect, useState } from "react";
import { ChatMuteHoc, ChatMuteOffHoc } from "../../../assets/images";
import { getFromLocalStorageAndDecrypt } from "../../../Helpers/Chat/webChatEncryptDecrypt";
import CommonSwitch from "../Common/CommonSwitch";

const ChatMuteOption = (props = {}) => {
    const { isChatMute, handleChatMuteAction, chatId } = props;
    const [chatMuteState, setChatMuteState] = useState(isChatMute);
    useEffect(() => {
        const getMute = getFromLocalStorageAndDecrypt("tempMuteUser");
        let parserLocalStorage = getMute ? JSON.parse(getMute) : {};
        if (parserLocalStorage[chatId]) {
        setChatMuteState(true);
        } else {
        setChatMuteState(isChatMute);
        }
    }, [isChatMute]);
    return (
        <div className="about-no">
        <i className="MuteIcon">{!chatMuteState ? <ChatMuteOffHoc viewBox="0 0 21.191 16.994" /> : <ChatMuteHoc viewBox="0 0 19 17" />}</i>
        <span className="Mutetext">{"Mute"}</span>
        <CommonSwitch handleClick={() => handleChatMuteAction(!isChatMute)} id={1} checked={chatMuteState} />
        </div>
    );
};

export default ChatMuteOption;
